import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import {apiLinks} from "../core/api-links/api-links";
// config.service.ts
@Injectable({ providedIn: 'root' })
export class envConfigService {
  private config: any;

  constructor(private http: HttpClient) {}

  loadConfig() {
    return this.http.get(apiLinks.getENVConfig).toPromise()
  }

  get(key: string): any {
    return this.config?.[key];
  }

  getAll(): any {
    return this.config;
  }
}
